import apiClient from '@/services/axios'

export async function put(perkId, payload) {
  var response = await apiClient.put('/perks/' + perkId, payload)
  if (response) {
    return response.data
  }

  throw new Error('Unable to update Perk.')
}
